export default function (state) {
    let date = new Date();
    let dateY = new Date();
    dateY.setFullYear(dateY.getFullYear()+1);
        state.Id = '';
        state.Number = '';
        state.IssueDate = '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear();
        state.StartDate = '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear();
        state.EndDate = '' + (dateY.getDate() > 9 ? '' : '0') + dateY.getDate() + '.' + (dateY.getMonth() > 8 ? '' : '0') + (dateY.getMonth() + 1) + '.' + dateY.getFullYear();
        state.ContragentId = '';
        state.PartnerLegalId = '';
        state.ContragentName = '';
        state.ContragentType = '';
        state.OwnerLegalEntityId = '';
        state.CurrencyId = 1;
        state.Type = 1;
        state.IsPayed = false;
        state.IsUsed = false;
        state.Sum = 0;
        state.BankCommission = 0;
}